import { render, staticRenderFns } from "./PageGrade.vue?vue&type=template&id=3a8d8d06&scoped=true"
import script from "./PageGrade.vue?vue&type=script&lang=js"
export * from "./PageGrade.vue?vue&type=script&lang=js"
import style0 from "./PageGrade.vue?vue&type=style&index=0&id=3a8d8d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d8d06",
  null
  
)

export default component.exports